module.exports = "<nv-react-component component=\"CourseCommunications\"></nv-react-component>";